import { createSlice } from "@reduxjs/toolkit";
import { teamsInitialState, teamsReducerKey } from "./teams.constants";

export const teamsSlice = createSlice({
  name: teamsReducerKey,
  initialState: teamsInitialState,
  reducers: {
    setTeamId(state, { payload }) {
      state.teamId = payload;
    },
    setTeamState(state, { payload }) {
      state.teamState = payload;
    },
    setTeamCountry(state, { payload }) {
      state.teamCountry = payload;
    },
  },  
});
